// Others
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { urlApiChecklist } from '~/utils/constants/apis';
import { IChecklist, IChecklistForm, IFormCheckListItem, IQueryParamChecklist } from '~/utils/interface/checklist';

const checklistApi = {
  getChecklist: (params: IQueryParamChecklist) => {
    const url = urlApiChecklist.getChecklist;
    return axiosClient.get<IBaseResponse<IChecklist[]>>(url, { params });
  },

  createChecklist: (body: IChecklistForm) => {
    const url = urlApiChecklist.createChecklist;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  deleteChecklist: (id: string) => {
    const url = urlApiChecklist.deleteChecklist(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  deleteChecklistItem: (id: string) => {
    const url = urlApiChecklist.deleteChecklistItem(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  createChecklistItem: (body: IFormCheckListItem) => {
    const url = urlApiChecklist.createChecklistItem;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default checklistApi;
